// Punto de entrada de WORD BUILDERS.
import './styles/global.css';
import './styles/responsive.css';
import './styles/animations.css';
import { App } from './core/App.js';
import { pwa } from './core/PWA.js';

// PWA: registra el service worker y prepara la instalación.
pwa.init();

const canvas = document.getElementById('game-canvas');
const uiRoot = document.getElementById('ui-root');

// Aplica escala de texto persistida antes de renderizar.
const app = new App(canvas, uiRoot);
app.boot();

// El juego se puede jugar en HORIZONTAL y en VERTICAL. Marcamos la orientación en el <body>
// (`portrait`) para que el CSS aplique el layout adecuado. Ya no se fuerza a girar el móvil.
function updateOrientationGuard() {
  const portrait = window.matchMedia('(orientation: portrait)').matches;
  document.body.classList.toggle('portrait', portrait);
  document.body.classList.remove('show-rotate'); // nunca bloqueamos por orientación
}
window.addEventListener('resize', updateOrientationGuard);
window.addEventListener('orientationchange', updateOrientationGuard);
updateOrientationGuard();

// Expuesto para depuración desde consola.
window.WB = app;
